
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dealership/[dealershipId]/vehicle/[vehicleId]",
      function () {
        return require("private-next-pages/dealership/[dealershipId]/vehicle/[vehicleId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dealership/[dealershipId]/vehicle/[vehicleId]"])
      });
    }
  